import React from 'react';
import { useTranslation } from 'react-i18next';
import InfoPage from '../../InfoPage';

export default function TermsAndConditions() {
  const { t } = useTranslation();
  return (
    <InfoPage
      eyebrow={t('info.legalEyebrow')}
      title={t('legalPages.terms.title')}
      subtitle={t('legalPages.terms.subtitle')}
    >
      {/* Legal text is deliberately NOT machine-translated: a translation
          nobody has legally reviewed would carry meaning no one signed off
          on. The chrome localizes; the binding text stays English, and says
          so in the reader's language. */}
      <p className="info-english-notice"><em>{t('info.englishNotice')}</em></p>
      <p className="info-updated">Last updated: January 2026</p>

      <h2>1. Acceptance of Terms</h2>
      <p>
        By creating an account or using StarView Cinema's website or mobile app (together, the "Services"), you
        agree to these Terms & Conditions. Ticket purchases are additionally governed by our{' '}
        <a href="/starview-cinema-terms-and-conditions">StarView Cinema Terms &amp; Conditions</a>, which apply
        alongside this page.
      </p>

      <h2>2. Accounts</h2>
      <p>
        You're responsible for keeping your login credentials secure and for all activity under your account.
        Tell us immediately if you suspect unauthorized access. You must provide accurate account information,
        including your country, which determines your local pricing, language, and available payment methods.
      </p>

      <h2>3. Acceptable Use</h2>
      <p>You agree not to:</p>
      <ul>
        <li>Attempt to circumvent seat, ticket, or Galaxies-balance limits through automation or exploits.</li>
        <li>Resell tickets or Galaxies for commercial gain outside StarView's own sharing features.</li>
        <li>Interfere with the operation of the Services, including reverse-engineering security controls.</li>
        <li>Use a jailbroken, rooted, or otherwise compromised device to access purchase or payment features.</li>
      </ul>

      <h2>4. Galaxies and Rewards</h2>
      <p>
        Galaxies are a loyalty currency with no cash value, earned through real ticket purchases and redeemable
        for real rewards shown in the app. Galaxies balances, StarView X membership status, and reward
        eligibility may be adjusted to correct genuine errors or address fraud.
      </p>

      <h2>5. OrderUp Delivery</h2>
      <p>
        Food and drink orders placed through OrderUp are fulfilled by independent restaurants and delivered by
        independent drivers. StarView facilitates the order and payment; delivery times are estimates, not
        guarantees.
      </p>

      <h2>6. Intellectual Property</h2>
      <p>
        All StarView branding, app design, and original content are owned by StarView Cinema. Movie titles,
        posters, and trailers remain the property of their respective studios and are used under license or fair
        use for informational/promotional purposes.
      </p>

      <h2>7. Disclaimers</h2>
      <p>
        The Services are provided "as is." We work to keep showtimes, seat availability, and pricing accurate in
        real time, but errors can happen - StarView's liability for any such error is limited to a refund or
        credit for the affected order.
      </p>

      <h2>8. Changes to These Terms</h2>
      <p>
        We may update these Terms from time to time. Continuing to use the Services after an update means you
        accept the revised Terms.
      </p>

      <h2>9. Contact</h2>
      <p>
        Questions about these Terms can be sent to{' '}
        <a href="mailto:legal@starviewcinema.com">legal@starviewcinema.com</a>.
      </p>
    </InfoPage>
  );
}
